import React, { useContext, useState, useRef } from "react";
import './DashboardHead.css';
import { IClient } from "../../../../types/dashboard";
import { AppContext } from "../../../../appContext";
import { DashboardContext } from "../../DashboardContext";
import { CommonContextMenu } from "../../../../components/commonContextMenu/commonContextMenu";

interface IDashboardHeadProps{
    activeTag: string,
    setActiveTag: (index: string)=>void,
    onWrapClick: ()=>void;
    isWrap: boolean;
    client: IClient;
}

export const DashboardHead = ({activeTag, setActiveTag, onWrapClick, isWrap, client}: IDashboardHeadProps)=>{
    const tags = [
        'Form',
        'Lifeline',
        'Notes',
        'Treatment plan',
        'Statistic',
        'Analysis'
    ];
    const showTags = false;

    const {setActivePopup, setBottomSelected, setEditClientId, setSelectedBottomMenuTabId, isDashboardVisible, setIsDashboardVisible} = useContext(DashboardContext);
    
    const [contextMenuPosition, setContextMenuPosition] = useState<{top: number, left: number} | null>(null);
    const headerRef = useRef<HTMLDivElement>(null);
    
    const burgerClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        const rect = (e.target as HTMLElement).getBoundingClientRect();
        setContextMenuPosition({
            top: rect.bottom + 4,
            left: rect.right
        });
    }
    
    const handleEditClick = () => {
        setEditClientId(client.id);
        setSelectedBottomMenuTabId('');
        setActivePopup('EditClient');
        setContextMenuPosition(null);
    }
    
    const closeContextMenu = () => {
        setContextMenuPosition(null);
    }

    const {cheat, translate}  = useContext(AppContext)

    return (  
        <div ref={headerRef} className={`dashboard_right_head ${!isWrap ? '' : 'dashboard_right_head--open'}`}>
            <div className="dashboard_right_head_content">
                <div className="dashboard_right_head_content_left">
                    <div className="dashboard_right_head_user">
                        <div className="dashboard_right_head_avatar" style={{backgroundImage: `url(${client.avatarUrl})`}}>
                    
                        </div>
                        <div className="dashboard_right_head_info">
                            <div className="dashboard_right_head_name">
                                {client.name}
                            </div>
                            <div className="button dashboard_right_head_page" onClick={() => setIsDashboardVisible(!isDashboardVisible)}>
                                <div className="dashboard_right_head_page_text">
                                    {translate('dashboard_page_title')}
                                </div>
                                <svg className={`dashboard_right_head_page_button ${isDashboardVisible ? 'dashboard_right_head_page_button--visible' : ''}`} width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5 5L0 0H10L5 5Z" fill="currentColor"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="dashboard_right_head_content_right">
                    {showTags && <div className="dashboard_right_head_tags">
                        {tags.map(tag=><div className={`dashboard_right_head_tag ${tag == activeTag ? 'dashboard_right_head_tag--active' : ''}`}
                            onClick={()=>setActiveTag(tag)}
                        >
                            {tag}
                        </div>)}
                    </div>}
                    <div className="button dashboard_right_head_burger" onClick={burgerClick}>
                        
                    </div>
                </div>
            </div>
            {contextMenuPosition && headerRef.current && (
                <CommonContextMenu
                    position={contextMenuPosition}
                    boundingElement={headerRef.current}
                    onClose={closeContextMenu}
                >
                    <div className="button dashboard_head_contextMenu_item" onClick={handleEditClick}>
                        {translate('subtitles_context_edit')}
                    </div>
                </CommonContextMenu>
            )}
        </div>
    )
}